export const concerns = [
  {
    id: "01",
    label: "Whiter Teeth",
    patient: {
      name: "Emma",
      age: 34,
      concern: "Discoloration from coffee and time",
      direction: "In-clinic whitening + micro-polishing",
      image:
        "https://readdy.ai/api/search-image?query=Editorial%20portrait%20of%20a%2034%20year%20old%20woman%20with%20natural%20skin%20and%20soft%20natural%20smile%20sitting%20in%20a%20premium%20private%20dental%20clinic%20consultation%20room%2C%20visible%20dental%20chair%20and%20overhead%20examination%20light%20in%20soft%20background%2C%20cool%20neutral%20lighting%2C%20calm%20professional%20clinical%20environment%2C%20believable%20natural%20photography&width=900&height=1100&seq=hero-patient-emma&orientation=portrait",
    },
  },
  {
    id: "02",
    label: "Straighter Alignment",
    patient: {
      name: "Marcus",
      age: 29,
      concern: "Mild crowding on lower arch",
      direction: "Clear aligners over 8 months",
      image:
        "https://readdy.ai/api/search-image?query=Editorial%20portrait%20of%20a%2029%20year%20old%20man%20with%20natural%20skin%20and%20calm%20thoughtful%20expression%20in%20a%20premium%20private%20dental%20clinic%20with%20visible%20dental%20chair%20and%20clinical%20equipment%20softly%20blurred%20in%20background%2C%20cool%20professional%20lighting%2C%20believable%20natural%20portrait&width=900&height=1100&seq=patient-marcus&orientation=portrait",
    },
  },
  {
    id: "03",
    label: "Missing or Damaged Teeth",
    patient: {
      name: "Rahim",
      age: 52,
      concern: "Two missing molars, function loss",
      direction: "Dental implants with digital planning",
      image:
        "https://readdy.ai/api/search-image?query=Editorial%20portrait%20of%20a%2052%20year%20old%20middle%20eastern%20man%20with%20warm%20natural%20skin%20and%20quiet%20confident%20expression%20sitting%20in%20a%20premium%20dental%20clinic%20treatment%20room%20with%20dental%20chair%20and%20overhead%20light%20softly%20visible%2C%20professional%20believable%20clinical%20portrait&width=900&height=1100&seq=patient-rahim&orientation=portrait",
    },
  },
  {
    id: "04",
    label: "A More Balanced Smile",
    patient: {
      name: "Sofia",
      age: 41,
      concern: "Asymmetric front teeth after old work",
      direction: "Smile design with 6 veneers",
      image:
        "https://readdy.ai/api/search-image?query=Editorial%20portrait%20of%20a%2041%20year%20old%20woman%20with%20natural%20skin%20and%20subtle%20warm%20expression%20in%20a%20premium%20dental%20consultation%20room%20with%20visible%20intraoral%20scanner%20and%20dental%20monitor%20softly%20visible%20behind%2C%20cool%20neutral%20light%2C%20calm%20clinical%20premium%20photography&width=900&height=1100&seq=patient-sofia&orientation=portrait",
    },
  },
  {
    id: "05",
    label: "Replacing Old Dental Work",
    patient: {
      name: "Daniel",
      age: 47,
      concern: "Aged crowns and mismatched shade",
      direction: "Full restoration with modern porcelain",
      image:
        "https://readdy.ai/api/search-image?query=Editorial%20portrait%20of%20a%2047%20year%20old%20man%20with%20natural%20skin%20looking%20slightly%20away%20from%20camera%20in%20a%20premium%20dental%20clinic%20treatment%20room%20with%20professional%20dental%20chair%20and%20overhead%20examination%20light%20softly%20behind%2C%20honest%20clinical%20portrait%20photography&width=900&height=1100&seq=patient-daniel&orientation=portrait",
    },
  },
  {
    id: "06",
    label: "I'm Not Sure Yet",
    patient: {
      name: "Talk to us",
      age: 0,
      concern: "Start with an open consultation",
      direction: "Online consultation and diagnostics",
      image:
        "https://readdy.ai/api/search-image?query=Warm%20portrait%20of%20a%20dentist%20in%20a%20professional%20clinical%20uniform%20speaking%20calmly%20with%20a%20patient%20in%20a%20premium%20private%20dental%20consultation%20room%20with%20visible%20dental%20model%20on%20desk%20and%20monitor%20showing%20dental%20scan%2C%20cool%20neutral%20lighting%2C%20believable%20clinical%20premium%20photography&width=900&height=1100&seq=patient-open&orientation=portrait",
    },
  },
];

export const caseRing = [
  {
    id: "case-01",
    name: "Emma, 34",
    treatment: "In-clinic Whitening",
    tier: "anchor" as const,
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20portrait%20of%20a%2034%20year%20old%20woman%20with%20natural%20skin%20and%20soft%20natural%20smile%20sitting%20in%20a%20premium%20private%20dental%20clinic%20consultation%20room%2C%20visible%20dental%20chair%20and%20overhead%20examination%20light%20in%20soft%20background%2C%20cool%20neutral%20lighting%2C%20calm%20professional%20clinical%20environment%2C%20believable%20natural%20photography&width=900&height=1100&seq=hero-patient-emma&orientation=portrait",
  },
  {
    id: "case-02",
    name: "Marcus, 29",
    treatment: "Clear Aligners",
    tier: "supporting" as const,
    image:
      "https://readdy.ai/api/search-image?query=Natural%20portrait%20of%20a%2029%20year%20old%20man%20with%20aligned%20natural%20teeth%20soft%20honest%20smile%20in%20warm%20neutral%20studio%20lighting%2C%20premium%20believable%20dental%20outcome%20photography%2C%20simple%20soft%20gray%20background&width=700&height=900&seq=case-marcus&orientation=portrait",
  },
  {
    id: "case-03",
    name: "Sofia, 41",
    treatment: "Smile Design",
    tier: "supporting" as const,
    image:
      "https://readdy.ai/api/search-image?query=Natural%20portrait%20of%20a%2041%20year%20old%20woman%20with%20balanced%20refined%20smile%20soft%20natural%20expression%20cool%20neutral%20studio%20light%20premium%20believable%20cosmetic%20dentistry%20outcome%20photography%20simple%20soft%20gray%20background&width=700&height=900&seq=case-sofia&orientation=portrait",
  },
  {
    id: "case-04",
    name: "Detail",
    treatment: "Veneer Close-up",
    tier: "supporting" as const,
    image:
      "https://readdy.ai/api/search-image?query=Close%20up%20macro%20detail%20of%20natural%20refined%20porcelain%20veneer%20smile%20with%20soft%20lip%20texture%20and%20cool%20neutral%20lighting%2C%20premium%20cosmetic%20dentistry%20result%20photography%2C%20simple%20clean%20background&width=700&height=700&seq=case-smile-detail-1&orientation=squarish",
  },
  {
    id: "case-05",
    name: "Detail",
    treatment: "Whitening Close-up",
    tier: "supporting" as const,
    image:
      "https://readdy.ai/api/search-image?query=Close%20up%20macro%20detail%20of%20naturally%20whitened%20teeth%20with%20soft%20lips%20cool%20neutral%20studio%20lighting%20premium%20believable%20dentistry%20outcome%20photography%20clean%20simple%20background&width=700&height=700&seq=case-smile-detail-2&orientation=squarish",
  },
  {
    id: "case-06",
    name: "Aiko, 33",
    treatment: "Clear Aligners",
    tier: "supporting" as const,
    image:
      "https://readdy.ai/api/search-image?query=Natural%20editorial%20portrait%20of%20a%2033%20year%20old%20east%20asian%20japanese%20woman%20with%20short%20dark%20hair%20soft%20honest%20calm%20smile%20and%20evenly%20aligned%20natural%20teeth%20in%20cool%20neutral%20studio%20lighting%20premium%20believable%20orthodontic%20outcome%20photography%20simple%20quiet%20gray%20background%20refined%20skin%20texture%20single%20subject%20centered%20composition%20no%20split%20no%20comparison%20line&width=800&height=900&seq=case-aiko-portrait&orientation=portrait&nocache=true",
  },
  {
    id: "case-07",
    name: "Julien, 44",
    treatment: "Porcelain Veneers",
    tier: "supporting" as const,
    image:
      "https://readdy.ai/api/search-image?query=Natural%20editorial%20portrait%20of%20a%2044%20year%20old%20man%20with%20refined%20balanced%20smile%20and%20soft%20confident%20expression%20in%20cool%20neutral%20studio%20lighting%20premium%20believable%20cosmetic%20dentistry%20outcome%20photography%20simple%20clean%20gray%20background%20single%20subject%20centered%20composition%20no%20split%20no%20comparison%20line&width=800&height=900&seq=case-julien-portrait&orientation=portrait&nocache=true",
  },
  {
    id: "case-08",
    name: "Rahim, 52",
    treatment: "Implants — Lifestyle",
    tier: "anchor" as const,
    image:
      "https://readdy.ai/api/search-image?query=Lifestyle%20portrait%20of%20a%2052%20year%20old%20middle%20eastern%20man%20with%20natural%20confident%20smile%20outside%20of%20clinical%20setting%20in%20soft%20natural%20daylight%20premium%20believable%20photography%20simple%20neutral%20background%2C%20honest%20mature%20outcome&width=900&height=1100&seq=case-rahim-lifestyle&orientation=portrait",
  },
];

export const practiceScenes = [
  {
    id: "arrive",
    tag: "01 Arrive",
    title: "A calmer arrival.",
    copy: "A quiet, private reception with clear signage — no crowded waiting rooms, no clinical chill.",
    image:
      "https://readdy.ai/api/search-image?query=Premium%20private%20dental%20clinic%20reception%20area%20with%20clear%20clinic%20signage%20professional%20front%20desk%20and%20calm%20waiting%20seating%2C%20cool%20neutral%20whites%20and%20light%20wood%20accents%2C%20visible%20clinical%20professional%20environment%20not%20a%20living%20room%2C%20soft%20natural%20lighting%20premium%20architectural%20photography&width=1600&height=1000&seq=practice-arrive&orientation=landscape",
  },
  {
    id: "consult",
    tag: "02 Consult",
    title: "Conversation, before treatment.",
    copy: "A private consultation room built for real dialogue — with digital scans, models and time to ask.",
    image:
      "https://readdy.ai/api/search-image?query=Premium%20private%20dental%20consultation%20room%20with%20dentist%20and%20patient%20talking%20at%20a%20consultation%20desk%20with%20dental%20model%20and%20monitor%20showing%20dental%20scan%20and%20intraoral%20scanner%20visible%2C%20cool%20neutral%20professional%20clinical%20environment%2C%20soft%20natural%20light%2C%20believable%20premium%20architectural%20photography&width=1600&height=1000&seq=practice-consult&orientation=landscape",
  },
  {
    id: "treat",
    tag: "03 Treat",
    title: "Precision, quietly delivered.",
    copy: "A treatment room built around the patient, with modern imaging, gentle handpieces and skilled hands.",
    image:
      "https://readdy.ai/api/search-image?query=Premium%20private%20dental%20treatment%20room%20with%20modern%20dental%20chair%20overhead%20dental%20examination%20light%20intraoral%20scanner%20and%20dental%20monitor%20clean%20clinical%20cabinetry%20and%20dentist%20in%20professional%20uniform%20preparing%20instruments%2C%20cool%20neutral%20whites%20soft%20light%20believable%20premium%20clinical%20photography&width=1600&height=1000&seq=practice-treat&orientation=landscape",
  },
];

export const firstVisit = [
  {
    id: "01",
    step: "Talk",
    title: "We listen first.",
    copy: "A calm, unrushed conversation about what you want to change — and what matters to you.",
    image:
      "https://readdy.ai/api/search-image?query=Dentist%20and%20patient%20talking%20in%20a%20premium%20private%20dental%20consultation%20room%20both%20seated%20at%20a%20consultation%20desk%20with%20dental%20model%20visible%2C%20warm%20honest%20human%20moment%2C%20cool%20neutral%20clinical%20lighting%20believable%20professional%20photography&width=1800&height=1100&seq=fv-talk&orientation=landscape",
  },
  {
    id: "02",
    step: "Scan",
    title: "Digital diagnostics.",
    copy: "A quick 3D intraoral scan replaces uncomfortable impressions — no guesswork.",
    image:
      "https://readdy.ai/api/search-image?query=Dentist%20performing%20real%20intraoral%20scan%20on%20a%20patient%20with%20visible%20intraoral%20scanner%20wand%20and%20dental%20monitor%20showing%20live%203d%20dental%20scan%2C%20premium%20private%20dental%20clinic%20cool%20neutral%20professional%20lighting%2C%20believable%20clinical%20photography&width=1800&height=1100&seq=fv-scan&orientation=landscape",
  },
  {
    id: "03",
    step: "Plan",
    title: "A plan you understand.",
    copy: "We walk through your scan and options together, with clear timelines and clear costs.",
    image:
      "https://readdy.ai/api/search-image?query=Dentist%20and%20patient%20reviewing%20a%20dental%20scan%20and%20treatment%20plan%20on%20a%20large%20monitor%20in%20a%20private%20consultation%20room%20with%20visible%20intraoral%20scanner%20and%20dental%20model%20on%20desk%2C%20cool%20neutral%20clinical%20environment%20believable%20professional%20photography&width=1800&height=1100&seq=fv-plan&orientation=landscape",
  },
  {
    id: "04",
    step: "Treat",
    title: "Precise, calm treatment.",
    copy: "Modern instruments, careful pacing and a room designed to keep you comfortable.",
    image:
      "https://readdy.ai/api/search-image?query=Dentist%20treating%20a%20patient%20in%20a%20modern%20premium%20dental%20treatment%20room%20with%20visible%20dental%20chair%20overhead%20examination%20light%20and%20intraoral%20scanner%2C%20calm%20focused%20clinical%20moment%2C%20cool%20neutral%20light%2C%20believable%20professional%20photography&width=1800&height=1100&seq=fv-treat&orientation=landscape",
  },
  {
    id: "05",
    step: "Follow Up",
    title: "We stay with you.",
    copy: "Follow-up reviews to make sure the result feels right — long after the treatment ends.",
    image:
      "https://readdy.ai/api/search-image?query=Dentist%20and%20patient%20in%20follow%20up%20review%20conversation%20in%20a%20premium%20dental%20consultation%20room%20with%20dental%20monitor%20softly%20visible%2C%20warm%20honest%20post%20treatment%20human%20moment%2C%20cool%20neutral%20clinical%20professional%20photography&width=1800&height=1100&seq=fv-follow&orientation=landscape",
  },
];

export const treatments = [
  {
    id: "01",
    name: "Porcelain Veneers",
    tag: "Natural restoration",
    timeline: "2–3 visits",
    suits: "Reshaping, mild misalignment, tone and balance",
    tech: "Custom hand-layered porcelain, digital smile planning",
    image:
      "https://readdy.ai/api/search-image?query=Close%20up%20of%20hand%20crafted%20porcelain%20dental%20veneers%20on%20a%20dental%20model%20in%20a%20premium%20dental%20laboratory%20with%20visible%20dental%20instruments%20and%20soft%20cool%20neutral%20studio%20lighting%2C%20believable%20premium%20cosmetic%20dentistry%20craft%20photography&width=1200&height=900&seq=tx-veneers&orientation=landscape",
  },
  {
    id: "02",
    name: "Clear Aligners",
    tag: "Gentle straightening",
    timeline: "6–14 months",
    suits: "Mild to moderate crowding and spacing",
    tech: "3D treatment planning, staged clear aligner trays",
    image:
      "https://readdy.ai/api/search-image?query=Set%20of%20clear%20dental%20aligner%20trays%20on%20a%20clean%20clinical%20tray%20next%20to%20intraoral%20scanner%20in%20a%20premium%20dental%20clinic%20with%20cool%20neutral%20studio%20lighting%2C%20believable%20premium%20orthodontics%20product%20photography&width=1200&height=900&seq=tx-aligners&orientation=landscape",
  },
  {
    id: "03",
    name: "Whitening",
    tag: "Brighter, but natural",
    timeline: "1–2 visits",
    suits: "Coffee, wine or age-related discoloration",
    tech: "In-clinic activation, at-home refinement trays",
    image:
      "https://readdy.ai/api/search-image?query=Professional%20in%20clinic%20teeth%20whitening%20treatment%20setup%20with%20visible%20dental%20chair%20overhead%20light%20and%20whitening%20equipment%20in%20a%20premium%20dental%20clinic%20cool%20neutral%20lighting%2C%20believable%20premium%20clinical%20photography&width=1200&height=900&seq=tx-whitening&orientation=landscape",
  },
  {
    id: "04",
    name: "Implants",
    tag: "Restoring function",
    timeline: "3–6 months",
    suits: "One or several missing teeth",
    tech: "Guided digital planning, titanium implants",
    image:
      "https://readdy.ai/api/search-image?query=Digital%20dental%20implant%20treatment%20planning%20on%20a%20large%20monitor%20next%20to%20dental%20model%20and%20titanium%20implant%20components%20on%20clean%20clinical%20tray%20in%20premium%20dental%20clinic%20cool%20neutral%20professional%20lighting%2C%20believable%20premium%20clinical%20photography&width=1200&height=900&seq=tx-implants&orientation=landscape",
  },
  {
    id: "05",
    name: "Smile Design",
    tag: "Everything, together",
    timeline: "Custom",
    suits: "Full smile refinement across multiple concerns",
    tech: "Digital smile design, mock-ups, layered restorations",
    image:
      "https://readdy.ai/api/search-image?query=Dentist%20reviewing%20a%20digital%20smile%20design%20mock%20up%20on%20a%20large%20monitor%20with%20dental%20model%20visible%20on%20consultation%20desk%20in%20premium%20dental%20clinic%20cool%20neutral%20professional%20lighting%2C%20believable%20clinical%20photography&width=1200&height=900&seq=tx-smile-design&orientation=landscape",
  },
];

export const pricing = [
  { name: "Initial Consultation", price: "€90" },
  { name: "Professional Whitening", price: "from €480" },
  { name: "Clear Aligners", price: "from €2,900" },
  { name: "Porcelain Veneers", price: "from €780 / tooth" },
  { name: "Dental Implant", price: "from €2,400" },
];

export const faqs = [
  {
    q: "Will treatment hurt?",
    a: "Most treatments are painless with modern anesthetic techniques. For more sensitive patients we offer gentle sedation options and always work at your pace.",
  },
  {
    q: "Will the result look natural?",
    a: "Yes — this is the core of our practice. Every restoration is designed around your face and existing features. The best result shouldn't look like treatment.",
  },
  {
    q: "How long does treatment take?",
    a: "It depends on the treatment. Whitening is one or two visits; aligners run 6–14 months; veneers 2–3 visits over a few weeks; implants 3–6 months.",
  },
  {
    q: "What happens at my first consultation?",
    a: "A conversation, a digital scan and a plan you understand. No commitment — you leave with clear options and a clear cost.",
  },
  {
    q: "Can I pay in instalments?",
    a: "Yes — we offer flexible instalment plans for larger treatments, discussed openly before you commit.",
  },
];